require('property/form-search');


function showForm(selectedType) {
    $('.alert-creation-type').hide();
    $('.alert-creation--' + selectedType).show();
}

$(document).ready(function(){

    if($('.alert-creation-content--pre-choice').length) {
        showForm($('.alert-creation-content--pre-choice:checked').val());
    }
    
    $('.alert-creation-content--pre-choice').on('change', function(e){
        var selectedType = $('.alert-creation-content--pre-choice:checked').val();
        showForm(selectedType);

    });


    $('#email','.alert-creation-form-input-email').on('keyup', function(e){
        $('.email-hidden').val(($(this).val()));
    });
    $('#email','.alert-creation-form-input-email').on('change', function(e){
        $('.email-hidden').val(($(this).val()));
    });
    $('#email','.alert-creation-form-input-email').on('blur', function(e){
        $('.email-hidden').val(($(this).val()));
    });





    $('#buySearch').PropertyFormSearch({
        typeTransactionSelector             : '#alertBuyFormtypeTransaction',
        typeSelectSelector                  : '#alertBuyFormTypeSelect',
        locationSelector                    : '#alertBuyFormLocation',
        alertContainerSelector              : '#alertBuyFormAlertContainer',
        moreOptionsBtnSelector              : '#alertBuyFormMoreOptionsBtn',
        advancedOptionsContainerSelector    : '#alertBuyFormAdvancedSearchContainer',
        advancedOptionsInputSelector        : '.type-dependant',
        moreOptionsBtnActivatedHtml         : '<i class="fa fa-minus"></i>',
        moreOptionsBtnUnactivatedHtml       : '<i class="fa fa-plus"></i>',
        skipLocationValidation              : false,
        typeBienCallback                    : function(){
            var closestPropTypes = $(this).closest('.prop-types');
            var input = $('.select2-search__field',closestPropTypes);
            var placeHolder = $(this).data('placeholder');
            if(!placeHolder){
                placeHolder = 'Type de bien';
            }
            input.attr('placeHolder', placeHolder);
            input.attr('id', 'noKbd');
        },
        onSubmit                            : function(e) {
            $('.email-hidden').val($('#email','.alert-creation-form-input-email').val());
        },
    });
    $('#alertBuyFormMoreOptionsBtn').click().click();


    $('#rentSearch').PropertyFormSearch({
        typeTransactionSelector             : '#alertRentFormtypeTransaction',
        typeSelectSelector                  : '#alertRentFormTypeSelect',
        locationSelector                    : '#alertRentFormLocation',
        alertContainerSelector              : '#alertRentFormAlertContainer',
        moreOptionsBtnSelector              : '#alertRentFormMoreOptionsBtn',
        advancedOptionsContainerSelector    : '#alertRentFormAdvancedSearchContainer',
        advancedOptionsInputSelector        : '.type-dependant',
        moreOptionsBtnActivatedHtml         : '<i class="fa fa-minus"></i>',
        moreOptionsBtnUnactivatedHtml       : '<i class="fa fa-plus"></i>',
        skipLocationValidation              : false,
        typeBienCallback                    : function(){
            var closestPropTypes = $(this).closest('.prop-types');
            var input = $('.select2-search__field',closestPropTypes);
            var placeHolder = $(this).data('placeholder');
            if(!placeHolder){
                placeHolder = 'Type de bien';
            }
            input.attr('placeHolder', placeHolder);
            input.attr('id', 'noKbd');
        },
        onSubmit                            : function(e) {
            $('.email-hidden').val($('#email','.alert-creation-form-input-email').val());
        },
    });

   


});
 